import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const MalaysiaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_15454'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_15454)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M20 0H9.52381V0.933333H20V0ZM20 1.86667H9.52381V2.8H20V1.86667ZM9.52381 3.73333H20V4.66667H9.52381V3.73333ZM20 5.6H9.52381V6.53333H20V5.6ZM0 7.46667H20V8.4H0V7.46667ZM20 9.33333H0V10.2667H20V9.33333ZM0 11.2H20V12.1333H0V11.2ZM20 13.0667H0V14H20V13.0667Z'
					fill='#E1244A'
				/>
				<rect
					width='11.4286'
					height='7.46667'
					fill='#0C3F8E'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M4.76144 6.53335C5.43652 6.53335 6.05692 6.3039 6.54586 5.92025C6.28685 6.01493 6.0065 6.06668 5.71382 6.06668C4.39886 6.06668 3.33287 5.02201 3.33287 3.73335C3.33287 2.44468 4.39886 1.40002 5.71382 1.40002C6.0065 1.40002 6.28685 1.45177 6.54586 1.54645C6.05691 1.16279 5.43652 0.93335 4.76144 0.93335C3.18348 0.93335 1.9043 2.18695 1.9043 3.73335C1.9043 5.27975 3.18348 6.53335 4.76144 6.53335ZM6.79214 5.41516L7.61858 4.49868L8.44503 5.41516L8.22916 4.21053L9.47559 4.14872L8.37995 3.56305L9.10779 2.5695L7.95743 3.04381L7.61858 1.86668L7.27974 3.04381L6.12938 2.5695L6.85721 3.56305L5.76158 4.14872L7.00801 4.21053L6.79214 5.41516Z'
					fill='#FFD34F'
				/>
			</g>
		</svg>
	);
};

export default MalaysiaFlagIcon;
